export default "__VITE_ASSET__3ae4f24a__"